import React from "react";
import "./Home.css";
import Product from "./Product";
function Home() {
  return (
    <div className="home">
      <img
        className="home_image"
        src="https://images-eu.ssl-images-amazon.com/images/G/31/prime/Events/Hush/Eventspage/GW/Prime_GW_Day_of_Headers_1500x600_Deals._CB408191898_.jpg"
        alt=""
      />
      {/* https://images-eu.ssl-images-amazon.com/images/G/31/AmazonVideo/2020/X-site/SingleTitle/BandishBandits/Launch/3000x1200_Hero-Tall_np._CB409765840_.jpg */}
      {/* https://images-eu.ssl-images-amazon.com/images/G/02/digital/video/merch2016/Hero/Covid19/Generic/GWBleedingHero_ENG_COVIDUPDATE__XSite_1500x600_PV_en-GB._CB428684220_.jpg */}
      <div className="home_row">
        <Product
          id="123457"
          title="Fossil Gen 5 Carlyle Touchscreen Men's Smartwatch"
          price={249}
          rating={4}
          image="https://images-na.ssl-images-amazon.com/images/I/714gQ5v%2B1ML._UX679_.jpg"
        />
        <Product
          id="123456"
          title="The Lean Startup"
          price={99}
          rating={5}
          image="https://m.media-amazon.com/images/I/81jgCiNJPUL._AC_UY218_.jpg"
        />
      </div>
      <div className="home_row">
        <Product
          id="123458"
          title="Hoteon UREVO Mask-3ply Disposable with Built-IN Nose Pin, PEE, Face Masks"
          price={20}
          rating={3}
          image="https://images-na.ssl-images-amazon.com/images/I/71IBJ6jSnuL._SX450_.jpg"
        />
        <Product
          id="123459"
          title="OnePlus 7T (Glacier Blue, 8GB RAM, Fluid AMOLED Display, 256GB Storage)"
          price={399}
          rating={5}
          image="https://images-na.ssl-images-amazon.com/images/I/71ncRs6HzyL._SX679_.jpg"
        />
        <Product
          id="123460"
          title="Reach Classic Recumbent Bike Exercise Cycle | Exercise Bike with Back Support Seat"
          price={99}
          rating={4}
          image="https://images-na.ssl-images-amazon.com/images/I/717a3rhNx%2BL._SX679_.jpg"
        />
      </div>
      <div className="home_row">
        <Product
          id="123461"
          title="PowerA Wired Officially Licensed Controller for Xbox One, Xbox One S, Xbox One X & Windows 10 - White"
          price={49}
          rating={3}
          image="https://images-na.ssl-images-amazon.com/images/I/71s6ZVKiezL._SX679_.jpg"
        />
      </div>
    </div>
  );
}

export default Home;
